<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="agentName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('代理商名称')}}<template slot="title">{{$t('代理商名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.agentName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('代理商名称')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="socialCreditCode" >
        <span slot="label" >
          <a-tooltip>
            {{$t('统一社会信用码')}}<template slot="title">{{$t('统一社会信用码')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.socialCreditCode" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('统一社会信用码')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="legalPersonName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('法人名称')}}<template slot="title">{{$t('法人名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.legalPersonName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('法人名称')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="legalPersonIdCard" >
        <span slot="label" >
          <a-tooltip>
            {{$t('法人身份证号')}}<template slot="title">{{$t('法人身份证号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.legalPersonIdCard" :maxLength="20" :placeholder="$t('通用.输入.请输入')+$t('法人身份证号')" disabled/>
      </a-form-model-item>
      <a-form-model-item prop="legalPersonPhone" >
        <span slot="label" >
          <a-tooltip>
            {{$t('法人手机')}}<template slot="title">{{$t('法人手机')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.legalPersonPhone" :maxLength="20" :placeholder="$t('通用.输入.请输入')+$t('法人手机')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="legalPersonDocumentNumber" >
        <span slot="label" >
          <a-tooltip>
            {{$t('法人证件号')}}<template slot="title">{{$t('法人证件号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.legalPersonDocumentNumber" :maxLength="50" :placeholder="$t('通用.输入.请输入')+$t('法人证件号')"  disabled />
      </a-form-model-item>
      <a-form-model-item prop="applicationDate" >
        <span slot="label" >
          <a-tooltip>
            {{$t('代理申请日期')}}<template slot="title">{{$t('代理申请日期')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.applicationDate" format="YYYY-MM-DD HH:mm:ss" allow-clear disabled/>
      </a-form-model-item>
<!--      <a-form-model-item prop="registeredAddress" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('代理商注册地址')}}<template slot="title">{{$t('代理商注册地址')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.registeredAddress" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('代理商注册地址')" disabled />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="mallAccount" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('商城关联账号')}}<template slot="title">{{$t('商城关联账号')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.mallAccount" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('商城关联账号')"  disabled/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="iotAccount" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('物联关联账号')}}<template slot="title">{{$t('物联关联账号')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.iotAccount" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('物联关联账号')" disabled />-->
<!--      </a-form-model-item>-->
      <a-form-model-item prop="contactNumber" >
        <span slot="label" >
          <a-tooltip>
            {{$t('联系方式')}}<template slot="title">{{$t('联系方式')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactNumber" :maxLength="20" :placeholder="$t('通用.输入.请输入')+$t('联系方式')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="contactAddress" >
        <span slot="label" >
          <a-tooltip>
            {{$t('联系地址')}}<template slot="title">{{$t('联系地址')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactAddress" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('联系地址')" disabled />
      </a-form-model-item>
      <a-form-model-item prop="detailedAddress" >
        <span slot="label" >
          <a-tooltip>
            {{$t('详细地址')}}<template slot="title">{{$t('详细地址')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.detailedAddress" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('详细地址')"  disabled />
      </a-form-model-item>
      <a-form-model-item prop="cooperationNotes" >
        <span slot="label" >
          <a-tooltip>
            {{$t('合作备注')}}<template slot="title">{{$t('合作备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.cooperationNotes" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear disabled />
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="reviewStatus" >
        <a-select placeholder="请选择审核状态" v-model="form.reviewStatus">
          <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="parseInt(d.value)" >{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
     <!--  <a-form-model-item prop="reviewStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('审核状态')}}<template slot="title">{{$t('审核状态')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item> -->
     <!--  <a-form-model-item prop="reviewer" >
        <span slot="label" >
          <a-tooltip>
            {{$t('审核人')}}<template slot="title">{{$t('审核人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reviewer" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('审核人')" />
      </a-form-model-item>
      <a-form-model-item prop="reviewTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('审核时间')}}<template slot="title">{{$t('审核时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.reviewTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item> -->
      <a-form-model-item prop="reasonDesc" >
        <span slot="label" >
          <a-tooltip>
            {{$t('原因说明')}}<template slot="title">{{$t('原因说明')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reasonDesc" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAgents, addAgents, updateAgents } from '@/api/user/agents'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        agentName: null,

        socialCreditCode: null,

        legalPersonName: null,

        legalPersonIdCard: null,

        legalPersonPhone: null,

        legalPersonDocumentNumber: null,

        applicationDate: null,

        registeredAddress: null,

        mallAccount: null,

        iotAccount: null,

        contactNumber: null,

        contactAddress: null,

        detailedAddress: null,

        cooperationNotes: null,

        reviewStatus: '0',

        reviewer: null,

        reviewTime: null,

        reasonDesc: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        agentName: [
          { required: true, message: this.$t('代理商名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('统一社会信用码')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: this.$t('法人名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        legalPersonIdCard: [
          { required: true, message: this.$t('法人身份证号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        legalPersonPhone: [
          { required: true, message: this.$t('法人手机')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        legalPersonDocumentNumber: [
          { required: true, message: this.$t('法人证件号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        registeredAddress: [
          { required: true, message: this.$t('代理商注册地址')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        mallAccount: [
          { required: true, message: this.$t('商城关联账号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        iotAccount: [
          { required: true, message: this.$t('物联关联账号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        contactNumber: [
          { required: true, message: this.$t('联系方式')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        contactAddress: [
          { required: true, message: this.$t('联系地址')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        detailedAddress: [
          { required: true, message: this.$t('详细地址')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        agentName: null,
        socialCreditCode: null,
        legalPersonName: null,
        legalPersonIdCard: null,
        legalPersonPhone: null,
        legalPersonDocumentNumber: null,
        applicationDate: null,
        registeredAddress: null,
        mallAccount: null,
        iotAccount: null,
        contactNumber: null,
        contactAddress: null,
        detailedAddress: null,
        cooperationNotes: null,
        reviewStatus: '0',
        reviewer: null,
        reviewTime: null,
        reasonDesc: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAgents({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateAgents(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addAgents(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
